export const KW = "kW";
export const KWH = "kWh";
export const VOLT = "V";
export const AMP = "A";
export const HERTZ = "Hz";
export const PERCENT = "%";
export const KILOVOLTAMPERE = "kVA";
